import type { App } from 'vue';
import { withFirebase, withTheme } from 'freedom-shared';

import { sentryModel } from '@/shared/model';

import { withI18n } from './with-i18n';
import { withPinia } from './with-pinia';
import { withSentry } from './with-sentry';
import { withBloomreachTriggerBroker } from './with-bloomreach-trigger-broker';
import { withFreedomApp } from './with-freedom-app';
import { withVueQuery } from './with-vue-query';
import { withDebugBar } from './with-debug-bar';
import { withAmplitude } from './with-amplitude';
import { withGoogleAnalytics } from './with-google-analytics';
import { withCfTurnstile } from './with-cf-turnstile';
import { withStatusBarHeight } from './with-status-bar-height';
import { withRouter } from './with-router';

export const withProviders = async (app: App) => {
  withBloomreachTriggerBroker();
  withGoogleAnalytics();
  withFreedomApp();
  withVueQuery(app);
  await withI18n(app);
  withPinia(app); // Pinia before sentry, since sentry needs it
  withDebugBar(); // Debug bar before firebase and amplitude to record its requests
  const router = withRouter(app);
  withSentry(app, router);
  withCfTurnstile();
  withAmplitude();
  withFirebase(sentryModel);
  withStatusBarHeight();
  withTheme();
};
